module.exports = __webpack_public_path__ + "static/Muli-Light-46b0b7979bf19b2a4f189358ea74ff06.ttf";